import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import personFormConfig from '../config/person-form-config.json';
import { DynamicFormService } from '../../../../services/dynamic-form.service';
import { DynamicForm } from '../../../../models/dynamic-form';
import { ApiService } from '../../../../services/api.service';
import { ToasterService } from '../../../../services/toaster.service';
import { LoadingService } from '../../../../services/loading.service';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.component';
import { ContactInformation } from '../../../../models/masters/contact-information.interface';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { ContactActions, ContactService } from '../../../../services/masters/contact.service';
import { CONTACT_ACTIONS } from '../../../../services/masters/contact.service';
@Component({
  selector: 'app-contact-information',
  standalone: true,
  imports: [SvgIconComponent, DynamicFormComponent, SharedModule],
  templateUrl: './contact-information.component.html',
  styleUrl: './contact-information.component.scss'
})
export class ContactInformationComponent {

  @Input() contactForm!: FormGroup;
  @Input() contactFormConfig!: DynamicForm;
  @Input() contactInformation!: ContactInformation;
  @Input() action!: ContactActions;

  readonly: boolean = false;

  @Output() onValueChange = new EventEmitter<{controlName: string, result: any}>();

  personFormConfig!: DynamicForm;


  constructor(private dynamicFormService: DynamicFormService,
    private api: ApiService,
    private toasterService: ToasterService,
    private loadingService: LoadingService,
    private fb: FormBuilder,
    private contactService: ContactService
  ) {
    this.personFormConfig = personFormConfig as DynamicForm;
    this.contactForm = this.fb.group({
      id: [null],
      sez: [false],
      contactPersons: this.fb.array([])
    });
  }

  ngOnInit() {
    this.readonly = this.action === CONTACT_ACTIONS.VIEW;
    this.initialiseContactForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contactInformation'] && this.contactInformation) {
      this.patchContactData(this.contactInformation);
    }
  }

  patchContactData(contactInformation: ContactInformation) {
    this.contactService.patchContactForm(this.contactForm, this.contactInformation, this.action);
  }

  private initialiseContactForm() {
    this.dynamicFormService.addControlsToForm(this.contactForm, this.contactFormConfig);
    if (this.contactInformation) {
      if (this.contactInformation.contactPersons?.length) {
        this.contactInformation.contactPersons.forEach(contactPerson => {
          this.addContactPerson();
        });
      }

      this.contactService.patchContactForm(this.contactForm, this.contactInformation, this.action);
    }

    if (this.contactPersons.length === 0 && this.action !== CONTACT_ACTIONS.VIEW) {
      this.addContactPerson();
    }

    if (this.action === CONTACT_ACTIONS.VIEW) {
      this.contactForm.disable();
    }
  }

  addContactPerson() {
    if (this.contactPersons.length >= 3) {
      this.toasterService.error('You can only add up to 5 contact persons');
      return;
    }
    this.dynamicFormService.addToFormArray(this.contactForm, 'contactPersons', this.personFormConfig);
  }

  get contactPersons() {
    return this.contactForm.get('contactPersons') as FormArray;
  }

  removeContactPerson(index: number) {
    this.contactPersons.removeAt(index);
  }

  handleValueChange(event: any): void {
    const { controlName, result } = event;

    if (controlName === 'cityId') {
      this.handleCitySelection(result);
    } else if (controlName === 'sez') {
      this.handleSezChange(result);
    } else if (controlName === 'active') {
      this.handleContactActiveChange(result);
    }

    this.onValueChange.emit({controlName, result});
  }

  handleCitySelection(selectedCity: any) {
    const stateId = selectedCity.stateId;
    this.api.getStateMaster(stateId).subscribe({
      next: (res: any) => {
        this.contactForm.patchValue({
          stateId: { key: selectedCity.stateId, value: selectedCity.stateName },
          country: { key: res.data.country.id, value: res.data.country.name },
        });
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  handleSezChange(result: any) {
    if (this.readonly) return;
    if (result) {
      this.contactForm.get('sezCertificateNo')?.enable();
      this.contactForm.get('sezValidityDate')?.enable();
    } else {
      this.contactForm.get('sezCertificateNo')?.disable();
      this.contactForm.get('sezValidityDate')?.disable();
      this.contactForm.get('sezCertificateNo')?.setValue(null);
      this.contactForm.get('sezValidityDate')?.setValue(null);
    }
  }

  handleContactActiveChange(result: any) {
    if (this.readonly) return;

    if (result) {
      this.contactForm.get('defaultContact')?.enable();
    } else {
      this.contactForm.get('defaultContact')?.disable();
      this.contactForm.get('defaultContact')?.setValue(false);
    }
  }
}
